import React from 'react'
import PropTypes from 'prop-types'
import { getAccessibilityScript } from './getAccessiblityScript'
import { getOneTrustScript } from './getOneTrustScript'
import { getGrowthBookScript } from './getGrowthBookScript'

// We need to pass in helmet here because each <Helmet /> component
// updates a global instance
const AuctionApplicationProvider = ({
  children,
  Helmet,
  loadOneTrust,
  loadGrowthBookScript,
  accessibilityScriptOptions, // e.g. { equalweb: { ... } }
}) => {
  return (
    <>
      <Helmet>
        {loadOneTrust && (
          <script
            id='adc-injection-onetrust'
            innerHTML={getOneTrustScript()}
            type='module' // this will treat the inline similar to src and defer it
            defer // important - this script has to come after document loads
          />
        )}
        {accessibilityScriptOptions?.equalweb?.site_key &&
          accessibilityScriptOptions?.equalweb?.enabled && (
            <script
              id='adc-injection'
              innerHTML={getAccessibilityScript(
                accessibilityScriptOptions?.equalweb
              )}
              type='module' // this will treat the inline similar to src and defer it
              defer // important - this script has to come after document loads
            />
          )}
        {loadGrowthBookScript && (
          <script
            id='adc-injection'
            innerHTML={getGrowthBookScript()}
            type='module' // this will treat the inline similar to src and defer it
            defer // important - this script has to come after document loads
          />
        )}
      </Helmet>
      {children}
    </>
  )
}

AuctionApplicationProvider.propTypes = {
  children: PropTypes.node,
  Helmet: PropTypes.func.isRequired,
  loadOneTrust: PropTypes.bool,
  accessibilityScriptOptions: PropTypes.object,
  loadGrowthBookScript: PropTypes.bool,
}

export default AuctionApplicationProvider
